import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  companySettingForm: {
    "& h4": {
      marginLeft: 24,
    },
    [theme.breakpoints.up("lg")]: {
      padding: "40px 100px",
      "& .MuiGrid-item": {
        padding: "12px 40px",
      },
    },
    [theme.breakpoints.down("lg")]: {
      padding: "40px",
    },
    [theme.breakpoints.down("md")]: {
      padding: 24,
    },
    "& .chips-common": {
      display: "block",
    },
    "& .expand-btn": {
      position: "static",
      float: "right",
      padding: 0,
      width: 98,
    },
    "& .all-chips": {
      width: "100%",
    },
  },
  heading: {
    fontSize: 14,
    fontWeight: 500,
  },
  accordion: {
    boxShadow: "none",
    "&:before": {
      background: "none",
    },
    border: "solid 1px rgb(112 112 112 / 11%)",
    borderRadius: 7,
    marginBottom: 12,
    padding: 0,
    "&.Mui-expanded": {
      "& .MuiAccordionSummary-root": {
        background: "#F8F7F8",
        borderRadius: "7px 7px 0 0",
        color: "#000000",
      },
      "& .MuiAccordionSummary-expandIcon": {
        background: "#EEEDEE",
        border: "solid 1px #D0D0D1",
        "& svg": {
          color: "#858585",
        },
      },
    },
    "& .MuiAccordionSummary-root": {
      padding: "2px 12px",
    },
  },
  accordionSummary: {
    padding: 0,
    flexDirection: "row-reverse",
    height: "55px !important",
    minHeight: "55px !important",
    // [theme.breakpoints.down("xs")]: {
    //   height:'100px',
    // },
    "& .MuiIconButton-root": {
      padding: 0,
      background: "#EEEDEE",
      borderRadius: 3,
      marginRight: 15,
    },
    "& .MuiSwitch-root": {
      marginLeft: 20,
      "& .MuiIconButton-root": {
        background: "unset !important",
        marginRight: "0 !important",
        padding: "9px !important",
        borderRadius: "unset !important",
      },
    },
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
    },
  },
  accordionDetails: {
    padding: "15px 40px 16px",
    display: "block !important",
    [theme.breakpoints.down("xs")]: {
      padding: "0 8px 16px",
    },
    "& p": {
      margin: 0,
    },
    "& .MuiCheckbox-root": {
      padding: "0 10px",
    },
    "& .MuiFormControlLabel-root": {
      display: "flex",
      alignItems: "flex-start",
    },
  },
  performanceCycleAccordion: {
    paddingBottom: 8,
  },
  passwordList: {
    "& ul": {
      marginTop: "5px",
      padding: "0px 0 0 5px",
      "& li": {
        color: "#7B7A7A",
        fontSize: 12,
        lineHeight: "18px",
        listStyle: "none",
        position: "relative",
        paddingLeft: 15,
        "&:before": {
          content: "''",
          display: "inline-block",
          height: 8,
          width: 8,
          background: "#E7E7E7",
          borderRadius: "50%",
          position: "absolute",
          top: 5,
          left: 0,
        },
      },
    },
  },
  wrapperCard: {
    border: "1px solid #EDEDED",
    borderRadius: 4,
    padding: "4px",
    width: "100%",
    marginTop: 4,
    height: 280,
    "& .MuiInputBase-input": {
      padding: "16px 14px",
    },
    "& .input-btn": {
      bottom: 8,
    },
  },
  msgField: {
    "& .MuiInputBase-input": {
      height: "calc(100% - 20px)",
      minHeight: 100,
      padding: "8px 14px",
    },
    "& .MuiFormControl-root": {
      height: "100%",
    },
    "& .MuiInputBase-fullWidth": {
      height: "100%",
    },
    "& .textbox-root": {
      height: "100%",
    },
  },
  resetPadding: {
    "& .MuiGrid-item": {
      padding: "12px !important",
    },
  },
  qusList: {
    padding: 0,
    margin: 0,
    listStyle: "none",
    "& li": {
      display: "flex",
      "& svg": {
        marginRight: 8,
      },
    },
  },
  checkIcon: {
    color: "#33AF77",
  },
  crossIcon: {
    color: "#C2BDBD",
  },
}));
export default useStyles;
